import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../api";

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const refreshCategories = async () => {
    try {
      const data = await api.categories();
      setCategories(data);
    } catch (e) {
      console.error("categories load failed", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refreshCategories(); }, []);

  return (
    <DataContext.Provider value={{ categories, loading, refreshCategories }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => {
  const ctx = useContext(DataContext);
  if (!ctx) throw new Error("useData must be used within DataProvider");
  return ctx;
};
